<app-generic class="bottomsheet-menu" *ngIf="loaded" [structure]="structure" [param]="param"></app-generic>